import React from 'react'
import { MdOutlineBarChart } from 'react-icons/md'
import { FiUsers, FiPaperclip, FiType } from 'react-icons/fi'

const StatRow = ({ icon: Icon, iconColor, iconBg, label, value, valueColor, progress, max }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{
          width: 28, height: 28, borderRadius: '7px',
          background: iconBg,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <Icon style={{ fontSize: 13, color: iconColor }} />
        </div>
        <span style={{ fontSize: '12px', color: 'var(--secondary-text-color)', fontWeight: 500 }}>
          {label}
        </span>
      </div>
      <span style={{
        fontSize: '12px', fontWeight: 700,
        color: valueColor || 'var(--primary-text-color)'
      }}>
        {value}
      </span>
    </div>
    {progress !== undefined && (
      <div style={{
        height: '4px', borderRadius: '4px',
        background: 'rgba(255,255,255,0.08)', overflow: 'hidden'
      }}>
        <div style={{
          height: '100%',
          width: `${Math.min((progress / max) * 100, 100)}%`,
          background: progress / max > 0.8
            ? 'linear-gradient(90deg,#F97316,#EF4444)'
            : 'linear-gradient(90deg,#8660F8,#c4b5fd)',
          borderRadius: '4px',
          transition: 'width 0.4s ease'
        }} />
      </div>
    )}
  </div>
)

const QuickStatus = ({ selectedTagEmp, descriptionCount, attachmentsCount = 0 }) => {
  const charPercent = Math.min((descriptionCount / 250) * 100, 100)
  const charColor = charPercent > 80 ? '#F87171' : charPercent > 50 ? '#FBBF24' : '#4ADE80'

  return (
    <div style={{
      marginTop: '14px',
      background: 'var(--noti-widget-bg)',
      border: '1px solid var(--noti-widget-border)',
      borderRadius: '14px',
      padding: '16px 14px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.12)'
    }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
        <div style={{
          width: 30, height: 30, borderRadius: '8px',
          background: 'linear-gradient(135deg,#8660F8,#c4b5fd)',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <MdOutlineBarChart style={{ color: '#fff', fontSize: 15 }} />
        </div>
        <h3 style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
          Quick Stats
        </h3>
      </div>

      {/* Stats */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        <StatRow
          icon={FiType}
          iconColor="#c4b5fd"
          iconBg="#8660F820"
          label="Characters"
          value={
            <span>
              <span style={{ color: charColor }}>{descriptionCount}</span>
              <span style={{ color: 'var(--secondary-text-color)', fontWeight: 400 }}>/250</span>
            </span>
          }
          progress={descriptionCount}
          max={250}
        />

        <StatRow
          icon={FiUsers}
          iconColor="#60A5FA"
          iconBg="#3B82F620"
          label="Tagged people"
          value={
            <span style={{
              background: selectedTagEmp > 0 ? '#3B82F620' : 'transparent',
              border: selectedTagEmp > 0 ? '1px solid #3B82F640' : 'none',
              borderRadius: '20px', padding: selectedTagEmp > 0 ? '1px 8px' : '0',
              color: selectedTagEmp > 0 ? '#93C5FD' : 'var(--secondary-text-color)'
            }}>
              {selectedTagEmp}
            </span>
          }
        />

        <StatRow
          icon={FiPaperclip}
          iconColor="#4ADE80"
          iconBg="#22C55E20"
          label="Attachments"
          value={
            <span style={{
              background: attachmentsCount > 0 ? '#22C55E20' : 'transparent',
              border: attachmentsCount > 0 ? '1px solid #22C55E40' : 'none',
              borderRadius: '20px', padding: attachmentsCount > 0 ? '1px 8px' : '0',
              color: attachmentsCount > 0 ? '#86EFAC' : 'var(--secondary-text-color)'
            }}>
              {attachmentsCount > 0 ? `${attachmentsCount} file${attachmentsCount > 1 ? 's' : ''}` : '0'}
            </span>
          }
        />
      </div>

      {/* Readiness indicator */}
      <div style={{
        marginTop: '16px', padding: '10px 12px',
        borderRadius: '10px',
        background: descriptionCount > 0
          ? 'linear-gradient(135deg,#22C55E15,#22C55E08)'
          : 'rgba(255,255,255,0.03)',
        border: `1px solid ${descriptionCount > 0 ? '#22C55E30' : 'rgba(255,255,255,0.06)'}`,
        display: 'flex', alignItems: 'center', gap: '8px'
      }}>
        <span style={{ fontSize: '16px' }}>
          {descriptionCount > 0 ? '✅' : '📝'}
        </span>
        <span style={{
          fontSize: '11px', fontWeight: 500,
          color: descriptionCount > 0 ? '#4ADE80' : 'var(--secondary-text-color)'
        }}>
          {descriptionCount > 0
            ? 'Content ready to publish'
            : 'Add content to get started'}
        </span>
      </div>
    </div>
  )
}

export default QuickStatus
